import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import ReportsTable from "./components/ReportsTable";
import OrgCompanySelector, { isOrgAdmin } from "../../../components/orgCompanySelector/OrgCompanySelector";
import User from "../../../api/user";

export default function Reports() {
    const [selectedCompanyId, setSelectedCompanyId] = React.useState(null);
    const showOrgSelector = isOrgAdmin();

    const userInfo = User.GetInfo();
    const organizationId = userInfo?.organizationId || null;

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            {showOrgSelector && (
                <Flex mb="16px" px="10px">
                    <OrgCompanySelector
                        selectedCompanyId={selectedCompanyId}
                        onChange={setSelectedCompanyId}
                    />
                </Flex>
            )}
            <ReportsTable
                selectedCompanyId={selectedCompanyId}
                organizationId={organizationId}
            />
        </Box>
    );
}
